(function () {
  'use strict';

  var STATE_KEY = '__RSI_QUICK_ADD_RENDER__';

  console.log('se lanza')

  if (window[STATE_KEY]) return;

  window[STATE_KEY] = {
    running: false,
    processedModals: {}
  };

  var state = window[STATE_KEY];

  var MODAL_SELECTOR = 'quick-add-modal, .quick-add-modal, [id^="QuickAdd-"]';
  var BUTTONS_SELECTOR = '.product-form__buttons';
  var HOOK_SELECTOR = '[data-rsi-quick-add-hook="true"]';

  var observer = new MutationObserver(function () {
    var modals = document.querySelectorAll(MODAL_SELECTOR);

    for (var i = 0; i < modals.length; i++) {
      handleQuickAddModal(modals[i]);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function handleQuickAddModal(modal) {
    if (!modal) return;

    var modalKey = modal.id || modal.getAttribute('data-product-url') || 'quick-add';

    if (state.processedModals[modalKey]) {
      cleanupDuplicatedCodButtons(modal);
      return;
    }

    var buttonsWrapper = modal.querySelector(BUTTONS_SELECTOR);

    if (!buttonsWrapper) return;

    state.processedModals[modalKey] = true;

    createReleasitHook(buttonsWrapper);

    setTimeout(function () {
      initReleasit(modal);
    }, 300);
  }

  function createReleasitHook(container) {
    if (container.querySelector(HOOK_SELECTOR)) return;

    var hook = document.createElement('a');

    hook.href = '/rsi-btn-hook';
    hook.style.display = 'none';
    hook.setAttribute('data-rsi-quick-add-hook', 'true');

    container.appendChild(hook);
  }

  function initReleasit(modal) {
    if (state.running) return;

    if (!window._rsi || !window._rsi.productPage || !window._rsi.productPage.initFeatures) {
      return;
    }

    state.running = true;

    try {
      window._rsi.productPage.initFeatures();
    } catch (error) {
      console.warn('[Releasit QuickAdd] Error:', error);
    }

    setTimeout(function () {
      document.querySelector('.quick-add-modal #_rsi-buy-now-button').style.display = 'none';
      hideIcons();
    }, 100);
  }

function cleanupDuplicatedCodButtons(scope) {
  var codButtons = findCodButtons(scope);

  if (codButtons.length <= 1) return;

  for (var i = 0; i < codButtons.length - 1; i++) {
    codButtons[i].style.display = 'none';
    codButtons[i].setAttribute('data-rsi-hidden-duplicate', 'true');
  }
}

function findCodButtons(scope) {
  return Array.prototype.slice.call(
    scope.querySelectorAll('[id="_rsi-buy-now-button"]')
  );
}

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

    function hideIcons() {
      const releasitBtnIcons = document.querySelectorAll('._rsi-button-icon');
      const textBtn = document.querySelector('._rsi-buy-now-button > span');

      if (window.innerWidth < 767 && textBtn) {
        textBtn.style.setProperty('font-size', '14px', 'important');
      }

      if (!releasitBtnIcons.length) return;

      releasitBtnIcons.forEach((icon) => {
        icon.style.display = 'none';
      });
    }
    
    setTimeout(function () {
      hideIcons();
    }, 500);

})();